import React, { useState, useEffect } from "react";
import logo from "../../images/hkLogo.png";
import "./header.css";
import { useMediaQuery } from "@mui/material";
import ReorderIcon from "@mui/icons-material/Reorder";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageContext/LanguageContext";

function Header() {
  const { lang, toggleLanguage, t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const contactActive = location.hash === "#aboutUs";
  const isHomePage = location.pathname === "/";

  const handleContactClick = (e) => {
    e.preventDefault();
    navigate("/#aboutUs");
    setTimeout(() => {
      document.getElementById("aboutUs")?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };
  const isSmallerScreen = useMediaQuery("(max-width:600px)");
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (!isSmallerScreen) {
      document.querySelector(".header").style.borderRadius = "100px";
      setIsClicked(false);
    }
  }, [isSmallerScreen]);

  useEffect(() => {
    if (!isClicked) {
      document.querySelector(".header").style.borderRadius = "100px";
      document.querySelector(".header").style.backgroundColor = "#f1f1f149";
    }
  }, [isClicked]);

  const handleClick = () => {
    setIsClicked(!isClicked);
    document.querySelector(".header").style.borderRadius = "0";
    document.querySelector(".header").style.backgroundColor =
      "rgba(240, 248, 255, 0.739)";
  };

  return (
    <div className="header">
      <div className="logoContainer">
        <Link to="/">
          <img className="logo" src={logo} alt="HK Logo" />
        </Link>
      </div>

      {!isHomePage && (
        <button className="backBtn" onClick={() => navigate(-1)}>
          <ArrowBackIosNewIcon style={{ width: "1.2em", height: "1.2em" }} />
        </button>
      )}

      <div className={isClicked ? "contentBlock" : "content"}>
        <NavLink to="/" end className={({ isActive }) => isActive && !contactActive ? "active" : ""} onClick={() => setIsClicked(false)}>
          {t.home}
        </NavLink>
        <NavLink to="/Address" onClick={() => setIsClicked(false)}>{t.address}</NavLink>
        <NavLink to="/about" onClick={() => setIsClicked(false)}>{t.about}</NavLink>
        <NavLink to="/blog" onClick={() => setIsClicked(false)}>{t.blog}</NavLink>
        <a href="/#aboutUs" className={contactActive ? "active" : ""} onClick={(e) => { handleContactClick(e); setIsClicked(false); }}>{t.contact}</a>
        <a href="#">
          <button onClick={toggleLanguage} className="quote">
            {lang === "ar" ? "English" : "العربية"}
          </button>
        </a>
      </div>

      <button onClick={handleClick} className="expand">
        <ReorderIcon style={{ width: "2em", height: "2em" }} />
      </button>
    </div>
  );
}

export default Header;
